export const state = {
    currentActiveModal: '',
    loadingRequest: false,
};
